import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { colors } from '@material-ui/core';

import ReadingsHelpers from 'utils/ReadingsHelpers';

const useStyles = makeStyles(() => ({
  healthyBottom: {
    paddingBottom: 5,
    marginBottom: 2,
  },
  unhealthyBottom: {
    marginBottom: -4,
  },
  emptyLine: {
    padding: 20,
  },
  toolTipHeader: {
    fontSize: '18px',
    fontFamily: 'Roboto',
    marginBottom: 15,
    marginTop: 10,
  },
  toolTipBody: {
    fontSize: '14px',
    fontFamily: 'Roboto',
    display: 'flex',
  },
  toolTipSubtitle: {
    fontSize: '10px',
    fontFamily: 'Roboto',
    display: 'flex',
  },
  toolTipSubtitleHeavy: {
    fontSize: '12px',
    fontFamily: 'Roboto',
    display: 'flex',
    fontWeight: 'bold',
  },
  normal: {
    color: 'green',
  },
  lowNormal: {
    color: 'goldenrod',
  },
  highNormal: {
    color: 'goldenrod',
  },
  lowWarn: {
    color: 'darkorange',
  },
  highWarn: {
    color: 'darkorange',
  },
  lowCritical: {
    color: 'orangered',
  },
  highCritical: {
    color: 'orangered',
  },
  error: {
    color: 'red',
  },
  default: {
    color: colors.grey[900],
  },
}));

const TelemetryMobileGridCell = ({
  telemetryType,
  depth,
  value,
  convertPPM,
  convertTemp,
  getInterval,
  getHealthStatus,
  convertUnits,
}) => {
  const convert = ReadingsHelpers.getNeedsConversion(telemetryType, convertPPM, convertTemp, convertUnits);

  const classes = useStyles();

  const display = ReadingsHelpers.displayReading(telemetryType, value, false, false, convert);
  const healthInterval = getInterval(telemetryType, depth);

  let convertedValue = value;
  if (ReadingsHelpers.readings[telemetryType]?.conversion) {
    convertedValue = ReadingsHelpers.readings[telemetryType]?.conversion(value);
  }
  const healthStatus = getHealthStatus(healthInterval, convertedValue);

  return (
    <Grid
      container
      item
      xs={12}
      direction="column"
      alignItems="center"
      justifyContent="center"
      key={Math.random() * 10000}
      className={classes.unhealthyBottom}
    >
      {value && (
        <Grid container item xs={12} key={Math.random() * 10000}>
          <Grid item xs={6} key={Math.random() * 10000}>
            <Typography key={Math.random() * 10000} align="center" variant="subtitle1">{`${depth * 6}"`}</Typography>
          </Grid>

          <Grid item xs={6} key={Math.random() * 10000}>
            {healthStatus ? (
              <Typography
                key={Math.random() * 10000}
                align="center"
                className={classes[healthStatus.status]}
                variant="subtitle1"
              >
                {display}
              </Typography>
            ) : (
              <Typography key={Math.random() * 10000} align="center" variant="subtitle1">
                {display}
              </Typography>
            )}
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

TelemetryMobileGridCell.propTypes = {
  healthIntervals: PropTypes.array,
  telemetryType: PropTypes.string,
  depth: PropTypes.number,
  value: PropTypes.number,
  getHealthStatus: PropTypes.func,
  getInterval: PropTypes.func,
  getSuggestion: PropTypes.func,
  showLineForEmpty: PropTypes.bool,
  final: PropTypes.bool,
  convertPPM: PropTypes.bool,
  convertTemp: PropTypes.bool,
  convertUnits: PropTypes.bool,
};

TelemetryMobileGridCell.defaultProps = {
  healthIntervals: [],
  telemetryType: '',
  depth: 0,
  value: 0,
  getHealthStatus: () => {},
  getInterval: () => {},
  showLineForEmpty: false,
  final: false,
  convertPPM: false,
  convertTemp: false,
  convertUnits: false,
  getSuggestion: () => {},
};

export default TelemetryMobileGridCell;
